<template>
  <main>
    <h2 class="ttl">
      <img
        src="/img/ico_user2.png"
        alt="会員情報の更新"
        width="40"
        class="mb30"
      /><br />{{ $t("updateUserInformation") }}
    </h2>
    <div class="account-box">
      <dl>
        <dt>{{ $t("firstName") }}</dt>
        <dd>
          <span
            v-if="
              !$v.profile.first_name_en.alpha ||
                !$v.profile.first_name_en.maxLength
            "
          >
            {{ $t(this.getMessage($v.profile.first_name_en, { name: "名" })) }}
          </span>
          <input
            type="text"
            id="name1"
            name="name1"
            placeholder="FIRST NAME"
            v-model.trim="$v.profile.$model.first_name_en"
          />
        </dd>
        <dt>{{ $t("lastName") }}</dt>
        <dd>
          <span
            v-if="
              !$v.profile.last_name_en.alpha ||
                !$v.profile.last_name_en.maxLength
            "
          >
            {{ $t(this.getMessage($v.profile.last_name_en, { name: "姓" })) }}
          </span>
          <input
            type="text"
            id="name2"
            name="name2"
            placeholder="LAST NAME"
            v-model.trim="$v.profile.$model.last_name_en"
          />
        </dd>
        <dt>{{ $t("middleName") }}</dt>
        <dd>
          <span
            v-if="
              !$v.profile.middle_name_en.alpha ||
                !$v.profile.middle_name_en.maxLength
            "
          >
            {{
              this.getMessage($v.profile.middle_name_en, {
                name: "MIDDLE NAME",
              })
            }}
          </span>
          <input
            type="text"
            id="name3"
            name="name3"
            placeholder="MIDDLE NAME"
            v-model.trim="$v.profile.$model.middle_name_en"
          />
        </dd>
        <dt>{{ $t("gender") }}</dt>
        <dd>
          <select name="pref" v-model.trim="$v.profile.$model.sex">
            <option disabled value="">{{ $t("chooseOption") }}</option>
            <option
              v-for="option in sex"
              :value="option.code"
              :key="option.code"
            >
              {{ $t(option.name) }}
            </option>
          </select>
        </dd>
        <dt>{{ $t("birthday") }}</dt>
        <dd>
          <moment
            @bindDate="bindDate"
            :propDate="this.profile.birthday"
          ></moment>
        </dd>
        <dt>{{ $t("nationality") }}</dt>
        <dd>
          <select v-model.trim="$v.profile.$model.country_code">
            <option disabled value="">{{ $t("chooseOption") }}</option>
            <option
              v-for="option in this.countries"
              :value="option.code"
              :key="option.code"
            >
              {{ option.name + " - " + option.name_en }}
            </option>
          </select>
          <br />
          <span class="txt-info block">
            {{ $t("infoNationality") }}
          </span>
        </dd>
        <dt
          v-if="
            this.profile.country_code !== 'JPN' &&
              this.profile.country_code !== ''
          "
        >
          {{ $t("zairyuDoc") }}
        </dt>
        <dd
          v-if="
            this.profile.country_code !== 'JPN' &&
              this.profile.country_code !== ''
          "
        >
          <select v-model.trim="$v.profile.$model.zairyuuShikaku">
            <option disabled value="">{{ $t("chooseOption") }}</option>
            <option
              v-for="option in this.zairyuu"
              :value="option.name"
              :key="option.name"
            >
              {{ option.name + " - " + option.name_en }}
            </option>
          </select>
          <br /><br />
          <div v-if="this.profile.zairyuuShikaku == 'その他'">
            <input
              type="text"
              id="zairyuOther"
              name="zairyuOther"
              placeholder="Zairyu status"
              v-model.trim="$v.profile.$model.zairyuOther"
            />
          </div>
        </dd>

        <dt>{{ $t("residenceArea") }}</dt>
        <dd>
          <select v-model.trim="$v.profile.$model.pref_code">
            <option disabled value="">{{ $t("chooseOption") }}</option>
            <option
              v-for="option in this.prefs"
              :value="option.code"
              :key="option.code"
            >
              {{ option.name + " - " + option.name_r }}
            </option>
          </select>
        </dd>
        <dt>{{ $t("nickname") }}</dt>
        <dd>
          <span v-if="!$v.profile.nickname.maxLength">
            {{
              $t(this.getMessage($v.profile.nickname, { name: "ニックネーム" }))
            }}
          </span>
          <input
            type="text"
            id="nickname"
            name="nickname"
            placeholder="NICK NAME"
            v-model.trim="$v.profile.$model.nickname"
          />
        </dd>
      </dl>
    </div>
    <p class="txt-error center mb40">
      <validationError :error="this.$v.$invalid && this.vaError" />
      <firebaseError :error="this.fbError" :errorCode="errorCode" />
    </p>
    <p class="btn-normal">
      <router-link to="" @click.native="update">{{
        $t("updateUserInformation")
      }}</router-link>
    </p>
  </main>
</template>

<script>
import firebase from "firebase";
import prefs from "@/constants/PrefsEnum";
import countries from "@/constants/CountriesEnum";
import sex from "@/constants/SexEnum";
import zairyuu from "@/constants/ZairyuStatusEnum";
import { maxLength, alpha } from "vuelidate/lib/validators";
import firebaseError from "@/error/FirebaseError";
import validationError from "@/error/ValidationError";
import moment from "@/components/Moment";
//const regex=helpers.regex('alpha',/^(0([1-9]{1}-?[1-9]\d{3}|[1-9]{2}-?\d{3}|[1-9]{2}\d{1}-?\d{2}|[1-9]{2}\d{2}-?\d{1})-?\d{4}|0[789]0-?\d{4}-?\d{4}|050-?\d{4}-?\d{4})$/);

export default {
  name: "AccountProfileEdit",
  mixins: [prefs, countries, sex, zairyuu],
  data() {
    return {
      db: firebase.firestore(),
      user: firebase.auth().currentUser,
      profile: {},
      profileCopy: {},
      vaError: false, //バリデーションエラー
      fbError: false, //firebaseエラー
      errorCode: "",
    };
  },
  components: {
    firebaseError,
    validationError,
    moment,
  },
  validations: {
    profile: {
      last_name_en: {
        alpha,
        maxLength: maxLength(100),
      },
      first_name_en: {
        alpha,
        maxLength: maxLength(100),
      },
      middle_name_en: {
        alpha,
        maxLength: maxLength(100),
      },
      nickname: {
        maxLength: maxLength(100),
      },
    },
  },
  created() {
    this.load();
  },
  methods: {
    bindDate(year, month, date) {
      if (
        this.isNotEmpty(year) &&
        this.isNotEmpty(month) &&
        this.isNotEmpty(date)
      ) {
        this.profile.birthday = new Date(year, month, date);
      }
    },
    assignField(profile, fieldName, data) {
      if (data[fieldName] !== undefined) profile[fieldName] = data[fieldName];
    },
    load() {
      this.db
        .collection("users")
        .doc(this.user.uid)
        .get()
        .then((doc) => {
          if (!doc.exists) {
            return;
          }
          const data = doc.data();
          const profileData = {};
          this.assignField(profileData, "last_name_en", data);
          this.assignField(profileData, "first_name_en", data);
          this.assignField(profileData, "middle_name_en", data);
          this.assignField(profileData, "sex", data);
          this.assignField(profileData, "country_code", data);
          this.assignField(profileData, "zairyuuShikaku", data);
          this.assignField(profileData, "zairyuOther", data);
          this.assignField(profileData, "nickname", data);
          if (data.birthday !== undefined) {
            profileData.birthday = data.birthday.toDate();
          }
          this.profile = profileData;
          this.profileCopy = JSON.parse(JSON.stringify(profileData));
          this.profileCopy.birthday = profileData.birthday;
        });
    },
    async update() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.vaError = true;
      } else {
        this.writeDB();
      }
    },
    async writeDB() {
      let docData = {};
      docData.updated_at = firebase.firestore.FieldValue.serverTimestamp();
      for (const property in this.profile) {
        docData[property] = this.profile[property];
      }
      if (
        this.profile.zairyuuShikaku !== "" &&
        this.profile.zairyuuShikaku !== undefined
      ) {
        docData.zairyuuShikaku = this.profile.zairyuuShikaku;
      }
      if (this.profile.zairyuuShikaku !== "その他") {
        docData.zairyuOther = "";
      } else {
        docData.zairyuOther = this.profile.zairyuOther;
      }
      if (docData.country_code == "JPN") {
        // if JPN remove zairyu information from data
        docData.zairyuuShikaku = firebase.firestore.FieldValue.delete();
        docData.zairyuOther = firebase.firestore.FieldValue.delete();
      }
      let phone = "";
      await this.db
        .collection("users")
        .doc(this.user.uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const data = doc.data();
            phone = data.phone;
          }
        });
      await this.db
        .collection("users")
        .doc(this.user.uid)
        .update(docData)
        .then(async () => {
          let updatedData = this.findNewData(this.profileCopy, this.profile);
          if (updatedData.length !== 0) {
            let logData = {};
            for (let key of updatedData) {
              logData["from_" + key] =
                this.profileCopy[key] == undefined ? "" : this.profileCopy[key];
              logData["to_" + key] = this.profile[key];
            }
            if (phone !== "") {
              logData.phone = phone;
            }
            logData.uid = this.user.uid;
            logData.updated_at = firebase.firestore.FieldValue.serverTimestamp();
            const updateLogRef = this.db.collection("usersUpdatesLog").doc();
            await updateLogRef.set(logData);
          }
          this.profileCopy = JSON.parse(JSON.stringify(this.profile));
          this.profileCopy.birthday = this.profile.birthday;
          this.$toasted.success(this.$t("successUpdate"));
        })
        .catch((error) => {
          this.errorCode = error.code;
          this.fbError = true;
          return;
        });
    },
    findNewData(oldData, newData) {
      let differentFields = [];
      for (const [key] of Object.entries(newData)) {
        if (oldData[key] !== newData[key]) {
          differentFields.push(key);
        }
      }
      return differentFields;
    },
  },
};
</script>
